// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function ProtectedRoute({ children }) {
  const { currentUser } = useAuth();

  if (!currentUser) {
    // Nếu không có user, điều hướng về trang login
    return <Navigate to="/login" />;
  }

  // Nếu có user, cho phép truy cập
  return children;
}

export default ProtectedRoute;